import classes from './bulkeditNoData.module.scss';

const BulkEditNoData = ({ label }: { label: string }) => {
  return (
    <div className={classes.container}>
      <div>{label}</div>
    </div>
  );
};

export default BulkEditNoData;
